import { render, staticRenderFns } from "./GiftcardsDashboard.vue?vue&type=template&id=34c8140e&"
import script from "./GiftcardsDashboard.vue?vue&type=script&lang=ts&"
export * from "./GiftcardsDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports